export const memberTypes = {
  MEMBER: "Member",
  ADMIN: "Admin",
  OWNER: "Owner",
};
